const INTRO_CONFIG = {
  active: false,
  sceneBlur: 6,
  isMusicEnabled: true,
}

export { INTRO_CONFIG };
